import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { shouldForwardProp } from '@ori/presentation-utils';
import { styled } from '@ori-ui/mui';
export var PriceRoot = styled('div')(function (_ref) {
  var theme = _ref.theme;
  return _defineProperty({
    alignItems: 'center',
    display: 'flex',
    gap: "0 ".concat(theme.spacing(3)),
    marginTop: theme.spacing(2)
  }, theme.breakpoints.up('sm'), {
    gap: "0 ".concat(theme.spacing(4)),
    marginTop: theme.spacing(1)
  });
});
export var CurrentPrice = styled('div', {
  shouldForwardProp: shouldForwardProp()
})(function (_ref3) {
  var isOffer = _ref3.isOffer,
    theme = _ref3.theme;
  return {
    fontSize: theme.typography.pxToRem(20),
    fontWeight: theme.typography.fontWeightBold,
    color: isOffer ? theme.palette.offer.main : undefined
  };
});
export var OldPrice = styled('div')(function (_ref4) {
  var theme = _ref4.theme;
  return {
    color: theme.palette.grey.A700,
    fontSize: theme.typography.pxToRem(12),
    textDecoration: 'line-through'
  };
});
//# sourceMappingURL=price.js.map